import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from '../shared/constants';
import { LoadOptions } from '../shared/models/shared.model';
import { UserResultModel } from '../shared/models/user.model';

@Injectable({
  providedIn: 'root'
})
export class UserGridService {
  private token = localStorage.getItem('token');
  private headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.token });

  private url = Constants.devServerEndpoint + 'api/usergrid';

  constructor(private httpClient: HttpClient) { }

  public getCompanyMappingGrid(param: LoadOptions): Observable<UserResultModel> {
	return this.httpClient
		.post<UserResultModel>(
			this.url + `/getUserGrid/`, param,
			{ headers: this.headers }
		);
  }

  public mappingAction(param): Observable<any> {
	return this.httpClient
		.post<any>(
			this.url + '/mappingAction', param,
			{ headers: this.headers }
		);
  }
}
